.image-repo--wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: var(--spacer) 0;

  img {
    max-width: 250px;
    margin-bottom: calc(3 * var(--spacer));
  }
}
